import { Checkbox, FormControlLabel, SxProps } from '@mui/material';
import {
  Controller,
  Control,
  FieldValues,
  ControllerRenderProps,
} from 'react-hook-form';

export interface CheckboxFieldProps {
  id: string;
  label: string;
  name?: string;
  defaultValue?: string;
  required?: boolean;
  control: Control<FieldValues, any>;
  labelPlacement?: 'bottom' | 'end' | 'start' | 'top';
  sx?: {
    label?: SxProps;
    checkbox?: SxProps;
  };
  disabled?: boolean;
  checked?: (field: ControllerRenderProps<FieldValues, string>) => boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
}

export const CheckBoxField = ({
  id,
  name,
  label,
  defaultValue,
  required = false,
  control,
  labelPlacement = 'end',
  sx,
  disabled = false,
  checked,
  onChange,
  readOnly = false,
}: CheckboxFieldProps) => {
  return (
    // controller is built in to react-hook-form and it allows your input to be registered with useForms internal state.
    <Controller
      rules={{ required }}
      control={control}
      name={name ?? id}
      defaultValue={defaultValue}
      render={({ field }) => {
        return (
          <FormControlLabel
            sx={{
              margin: '16px 5px',
              ...sx?.label,
            }}
            labelPlacement={labelPlacement}
            control={
              <Checkbox
                {...field}
                onChange={(e) => {
                  onChange && onChange(e);
                  field.onChange(e.target.checked);
                }}
                sx={{
                  color: '#4CAF50',
                  '&.Mui-checked': {
                    color: '#4CAF50',
                  },
                  ...sx?.checkbox,
                }}
                checked={
                  (checked && checked(field)) ||
                  typeof field.value === 'boolean'
                    ? field.value
                    : false
                }
                required={required}
                disabled={disabled}
                readOnly={readOnly}
              />
            }
            label={label}
          />
        );
      }}
    />
  );
};
